import React, { useCallback, useEffect, useState } from "react";
import Modal from "../Modal";
import { Grid, IconButton, Typography } from "@mui/material";
import "./saleDetail.css";
import "./yearlySales.css";
import { getIcon } from "utils/iconsConfig";
import TableSales from "./TableSales.jsx";
import TableYearlySale from "./TableYearlySale";
import { fetchDetails } from "./fetchDetails";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { useLocation, useParams } from "react-router-dom";

const SaleDetailsModal = ({ open, setOpen, styleNumber, type, fromStockInfo }) => {
  const [salesData, setSalesData] = useState([]);
  const [yearlySalesData, setYearlySetData] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [salesLoading, setSalesLoading] = useState(false);
  const [yearlySalesLoading, setYearlySalesLoading] = useState(false);
  const [salesError, setSalesError] = useState(null);
  const [yearlySalesError, setYearlySalesError] = useState(null);
  const permission = usePermissions();
  // const hasAccessToYearlyData = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Sales By Year"), "view");
  // const hasAccessToPublicData = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Sales By Client"), "view");
  const hasAccessToYearlyData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const hasAccessToPublicData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const [isYearSalesDetailsView, setIsYearSalesDetailsView] = useState(hasAccessToYearlyData);
  const location = useLocation();
  const { clientId } = useParams();

  const isClientFlow = location?.pathname?.includes("/client-flow/") ? true : false;

  const handleClose = useCallback(
    (e) => {
      e.stopPropagation();
      setOpen(false);
    },
    [setOpen, setIsYearSalesDetailsView]
  );

  const handleToggleSales = useCallback((e) => {
    e.stopPropagation();
    setIsYearSalesDetailsView((prev) => !prev);
  }, []);

  useEffect(() => {
    if (open && !isYearSalesDetailsView && styleNumber && salesData.length === 0 && type !== "Sets") {
      const fetchSales = async () => {
        const data = await fetchDetails({ url: `/api/v1/styles/salesBagTest`, method: "post", body: { styleNumber }, setLoading: setSalesLoading, setError: setSalesError });
        if (data) {
          setSalesData(Object.entries(data?.data).map(([key, value]) => ({ name: key, sale: value })) || []);
          setTotalSales(data?.salesCount || 0);
        }
      };
      fetchSales();
    }
  }, [open, isYearSalesDetailsView, styleNumber, salesData.length, type]);

  useEffect(() => {
    if (open && isYearSalesDetailsView && styleNumber && yearlySalesData.length === 0 && type !== "Sets") {
      const fetchYearlySales = async () => {
        const data = await fetchDetails({
          url: `/api/v1/styles/trendSalesYearly`,
          method: "get",
          params: {
            styleNumber,
            // clientName: isClientFlow ? JSON.stringify(sessionStorage.getItem("clientName") || "") : false,
            clientCode: isClientFlow ? clientId : false,
          },
          setLoading: setYearlySalesLoading,
          setError: setYearlySalesError,
        });
        if (data?.data) setYearlySetData(data?.data || []);
      };
      fetchYearlySales();
    }
  }, [open, isYearSalesDetailsView, styleNumber, yearlySalesData.length, type]);

  useEffect(() => {
    if (open && !isYearSalesDetailsView && styleNumber && salesData.length === 0 && type === "Sets") {
      const fetchSales = async () => {
        const data = await fetchDetails({ url: `/api/v1/set/salesBagTestForSet`, method: "post", body: { setNumber: styleNumber }, setLoading: setSalesLoading, setError: setSalesError });
        if (data) {
          setSalesData(Object.entries(data?.data).map(([key, value]) => ({ name: key, sale: value })) || []);
          setTotalSales(data?.salesCount || 0);
        }
      };
      fetchSales();
    }
  }, [open, isYearSalesDetailsView, styleNumber, salesData.length, type]);

  useEffect(() => {
    if (open && isYearSalesDetailsView && styleNumber && yearlySalesData.length === 0 && type === "Sets") {
      const fetchYearlySales = async () => {
        const data = await fetchDetails({
          url: `/api/v1/set/getTrendSetDetails`,
          method: "get",
          params: {
            setNumber: styleNumber,
          },
          setLoading: setYearlySalesLoading,
          setError: setYearlySalesError,
        });
        if (data?.data) setYearlySetData(data?.data || []);
      };
      fetchYearlySales();
    }
  }, [open, isYearSalesDetailsView, styleNumber, yearlySalesData.length, type]);

  return (
    <>
      <Modal open={open} handleClose={handleClose} style={{ width: isYearSalesDetailsView ? "310px" : "400px", ...(fromStockInfo && { mr: 55 }) }}>
        <Grid container spacing={2} className={isYearSalesDetailsView ? "yearly-sales-data" : "sale-modal"}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid">
            <Typography sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className={isYearSalesDetailsView ? "yearly-sales-data-heading" : "best-seller-heading"}>
              <IconButton disableFocusRipple disableRipple sx={{ p: 0, pr: 0.5 }}>
                {getIcon(isYearSalesDetailsView ? "date" : "public", "black")}
              </IconButton>
              {/* <div>{isYearSalesDetailsView ? `Trend Of ${styleNumber}` : `Sales Of ${styleNumber}`}</div> */}
              <div style={{ whiteSpace: "nowrap" }}>
                {isYearSalesDetailsView ? `Trend Of ${type === "Sets" ? `SET-${styleNumber}` : styleNumber}` : type === "Sets" ? `Sales Of SET-${styleNumber}` : `Sales Of ${styleNumber}`}
              </div>
            </Typography>
            <Typography sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <IconButton disableFocusRipple disableRipple sx={{ p: 0, pl: 1.5 }} onClick={handleToggleSales}>
                {getIcon(isYearSalesDetailsView ? hasAccessToPublicData && "public" : hasAccessToYearlyData && "date", "black")}
              </IconButton>
            </Typography>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="sub-grid scrollable-grid">
            {salesLoading || yearlySalesLoading ? (
              <h3>Loding ...</h3>
            ) : salesError || yearlySalesError ? (
              <h4 style={{ color: "red" }}>{salesError || yearlySalesError}</h4>
            ) : isYearSalesDetailsView ? (
              <TableYearlySale yearlySalesData={yearlySalesData} isClient={isClientFlow} />
            ) : (
              <TableSales salesData={salesData} totalSales={totalSales} />
            )}
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default SaleDetailsModal;
